import styled from 'styled-components'

export const Item = styled.div`
  position: relative;
  height: 100%;
  color: #424242;
  border: 1px solid #f7f7f7;
  border-radius: 8px;
  overflow: hidden;
  transition: 0.3s;

  &:hover {
    box-shadow: 0 0 20px #ccc;
  }

  h4 {
    text-transform: uppercase;
  }
`

export const Text = styled.div`
  padding: 15px;
`

export const DateNews = styled.p`
  margin: 0;
  color: #666;
  font-size: 12px;
`

export const Date = styled.div`
  position: absolute;
  right: 10px;
  bottom: 5px;
  font-size: 12px;

  @media (max-width: 400px) {
    position: unset;
    color: #A6AC97;
    font-size: 16px;
  }
`

export const Img = styled.div<{ big?: boolean | undefined }>`
  height: ${({ big }) => (big ? '338px' : '160px')};
  text-align: center;
  background-size: cover;
  background-position: center;
  //img {
  //  height: 100%;
  //}
`
